import PlateHeader from './m1nt/PlateHeader'

const SOURCE_STYLES = {
  owner: { label: 'Owner', icon: 'ri-user-3-line', className: 'border-m1-amber/50 text-m1-amber' },
  grader: {
    label: 'Grader',
    icon: 'ri-search-eye-line',
    className: 'border-m1-ice/50 text-m1-ice',
  },
  lab: {
    label: 'M1NT Lab',
    icon: 'ri-flask-line',
    className: 'border-m1-violet/50 text-m1-violet',
  },
}

export default function SourceBadge({ source, className = '' }) {
  const cfg = SOURCE_STYLES[source] || SOURCE_STYLES.owner
  return (
    <span
      className={`inline-flex items-center border px-2.5 py-0.5 font-m1-mono text-[11px] uppercase tracking-[0.12em] ${cfg.className} ${className}`}
    >
      {cfg.label}
    </span>
  )
}

export function SourceSectionHeader({ source, title, description }) {
  const cfg = SOURCE_STYLES[source] || SOURCE_STYLES.owner
  return (
    <PlateHeader
      icon={<i className={cfg.icon} />}
      eyebrow={cfg.label}
      title={title}
      subtitle={description}
    />
  )
}
